jQuery(function ($) {
    function updateGiftAid() {
        let val = $('[type="radio"][name="gift_aid"]:checked').val();
        if (val === "yes") {
            $('.gift_aid_extra').show();
        } else {
            $('.gift_aid_extra').hide();
        }
    }

    // show/hide House No / Postcode based on GiftAid option
    $('[type="radio"][name="gift_aid"]').on('change', updateGiftAid);
    updateGiftAid();
});
